// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileSkillsList_avatar__2SahS"};